var $5394997707852da6$exports = {};
$5394997707852da6$exports = {
    "loading": `\u{12E}keliama...`,
    "loadingMore": `\u{12E}keliama daugiau...`
};


export {$5394997707852da6$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
